var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkgreen09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 100",
    style: {
      enableBackground: "new 0 0 70 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#183D71;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#4C708B;}\r\n\t.st3{fill:#A7CBF0;}\r\n\t.st4{fill:#D4B653;}\r\n\t.st5{fill:#BA8A5E;}\r\n\t.st6{fill:#6F3D37;}\r\n\t.st7{fill:#667352;}\r\n\t.st8{fill:#9BA658;}\r\n\t.st9{fill:#0F3F2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.2,30.7l3,27c0.3,2.4,1.2,4.7,2.6,6.7C28.2,75.5,33.7,78.2,35,78.2c0.1,0,0.1,0,0.2,0V25.7 c-5,3.2-11.2,5.1-17.8,5.1C16.3,30.8,15.3,30.7,14.2,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M66.1,18.7C65.4,18.2,64.7,18,64,18c-0.5,0-1,0.1-1.4,0.3c-2.7,1.2-5.9,1.9-9.3,1.9c-7.6,0-14.1-3.5-16.8-8.4 c-0.2-0.4-0.6-0.6-1.1-0.6c-0.4,0-0.8,0.2-1.1,0.6c-1,1.9-2.6,3.5-4.5,4.8c-0.8,0.5-1.6,1-2.5,1.4c-0.2,0.1-0.4,0.2-0.6,0.3 c-0.7,0.3-1.3,0.6-2,0.8c-0.3,0.1-0.6,0.2-0.9,0.3c-0.7,0.2-1.4,0.3-2.1,0.5c-0.3,0.1-0.6,0.1-0.9,0.2c-1,0.1-2.1,0.2-3.2,0.2 c-3.6,0-7-0.8-9.9-2.2c-0.3-0.1-2-0.7-3.6,0.3c-1.1,0.7-1.6,2-1.5,3.3l4.2,37.2c0.5,4.3,2.1,8.4,4.7,11.9 c5.3,7.1,15,18.1,23.6,18.1c9,0,18.6-11.1,23.8-18.2c2.5-3.4,4.1-7.4,4.6-11.7l4.1-37.1C67.6,20.7,67.1,19.4,66.1,18.7z M58.1,58.4 c-0.4,3.4-1.6,6.4-3.6,9.1c-7.4,10-14.6,16-19.5,16c-4.6,0-12-6.1-19.4-16c-2-2.7-3.3-5.9-3.7-9.3L8.1,24c2.9,1,6.1,1.5,9.3,1.5 c7,0,13.5-2.5,17.9-6.6c4.4,4.1,10.9,6.6,17.9,6.6c3,0,5.9-0.4,8.7-1.3L58.1,58.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkgreen09);
export default __webpack_public_path__ + "static/media/darkgreen09.c0da9905c8aa58ebcb3ab3aa090a199a.svg";
export { ForwardRef as ReactComponent };